// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa6bYxvORc63Gv7yrVFD:hover .hc5aTtmAmUEUzWdXW3CM:after,
.fa6bYxvORc63Gv7yrVFD:hover .wjkg05fwSyvZXnjGAFYg,
.fa6bYxvORc63Gv7yrVFD:hover .euFHie3HEGREt0kod_TQ {
  visibility: visible;
  opacity: 1;
}
.fa6bYxvORc63Gv7yrVFD.am3oNEqAE_oqHZ553f8v .euFHie3HEGREt0kod_TQ {
  visibility: visible;
  opacity: 1;
}
.fa6bYxvORc63Gv7yrVFD.am3oNEqAE_oqHZ553f8v .hc5aTtmAmUEUzWdXW3CM:before {
  border-color: #2A85FF;
}

.hc5aTtmAmUEUzWdXW3CM:after,
.wjkg05fwSyvZXnjGAFYg,
.euFHie3HEGREt0kod_TQ {
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
}

.hc5aTtmAmUEUzWdXW3CM {
  position: relative;
  height: 200px;
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
}
.hc5aTtmAmUEUzWdXW3CM:after, .hc5aTtmAmUEUzWdXW3CM:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.2s;
}
.hc5aTtmAmUEUzWdXW3CM:after {
  background: rgba(17, 19, 21, 0.8);
}
.hc5aTtmAmUEUzWdXW3CM:before {
  z-index: 2;
  border: 2px solid transparent;
  border-radius: 12px;
  pointer-events: none;
}
.hc5aTtmAmUEUzWdXW3CM img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hc5aTtmAmUEUzWdXW3CM .euFHie3HEGREt0kod_TQ {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 3;
}
@media only screen and (max-width: 1023px) {
  .hc5aTtmAmUEUzWdXW3CM .euFHie3HEGREt0kod_TQ {
    display: none;
  }
}
.hc5aTtmAmUEUzWdXW3CM .euFHie3HEGREt0kod_TQ .Ah_d4lzc6k2QG8oAo8xy {
  border-color: #2A85FF;
}

.wjkg05fwSyvZXnjGAFYg {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  transform: translate(-50%, -50%);
}

.Spn9MrPYFe2yeGm1tHr0 {
  display: flex;
  align-items: flex-start;
}

.AeGzMBlNmKX5kV4lh80y {
  margin-right: auto;
}

.Daro9806tOD8YRw76NEI,
.vV7vQRKAu8RnsM02TuGV {
  flex-shrink: 0;
  display: inline-block;
  margin-left: 32px;
  padding: 0 8px;
  border-radius: 6px;
  line-height: 32px;
  font-weight: 700;
}

.Daro9806tOD8YRw76NEI {
  background: #B5E4CA;
}
.dark-mode .Daro9806tOD8YRw76NEI {
  color: #1A1D1F;
}

.vV7vQRKAu8RnsM02TuGV {
  background: #EFEFEF;
}
.dark-mode .vV7vQRKAu8RnsM02TuGV {
  background: #272B30;
  color: #FCFCFC;
}

.FUV1uamC7e52Hlvq1bDn {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #6F767E;
}
@media only screen and (max-width: 767px) {
  .FUV1uamC7e52Hlvq1bDn {
    margin-top: 2px;
  }
}
.FUV1uamC7e52Hlvq1bDn svg {
  margin-right: 8px;
  fill: #6F767E;
}

.HmVWO6n2Ch_70wFP1wW9 {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
}
@media only screen and (max-width: 767px) {
  .HmVWO6n2Ch_70wFP1wW9 {
    margin-top: 4px;
  }
}
.HmVWO6n2Ch_70wFP1wW9 svg {
  margin-right: 8px;
  fill: #FFC554;
}
.HmVWO6n2Ch_70wFP1wW9 span {
  margin-left: 4px;
  color: #6F767E;
}

.QPppTLeNGMGW3NDy9Znt {
  color: #6F767E;
}
.QPppTLeNGMGW3NDy9Znt svg {
  fill: #6F767E;
}`, "",{"version":3,"sources":["webpack://./src/components/Product/Product.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAIQ;;;EAGI,mBAAA;EACA,UAAA;AAHZ;AAKQ;EACI,mBAAA;EACA,UAAA;AAHZ;AAKY;EACI,qBCeX;ADlBL;;AAKA;;;EAGI,UAAA;EACA,kBAAA;EACA,oBAAA;AAFJ;;AAIA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAEI;EAEI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AADR;AAEI;EACI,iCAAA;AAAR;AACI;EACI,UAAA;EACA,6BAAA;EACA,mBAAA;EACA,oBAAA;AACR;AAAI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAER;AADI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAGR;AC/CI;EDwCA;IAMQ,aAAA;EAKV;AACF;AALQ;EACI,qBC/BP;ADsCL;;AALA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AAQJ;;AANA;EACI,aAAA;EACA,uBAAA;AASJ;;AAPA;EACI,kBAAA;AAUJ;;AARA;;EAEI,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAWJ;;AATA;EACI,mBCnDC;AD+DL;ACwFa;EDlGL,cC3CH;ADwDL;;AAXA;EACI,mBClDC;ADgEL;ACiFa;ED7FL,mBCjDH;EDkDG,cCvDH;ADsEL;;AAbA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;ECbA,eAAA;EACA,gBAAA;EACA,yBAAA;EDaA,cC3DC;AD6EL;ACzGI;EDkFJ;IAOQ,eAAA;EAoBN;AACF;AApBI;EACI,iBAAA;EACA,aChEH;ADsFL;;AApBA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;ECzBA,eAAA;EACA,gBAAA;EACA,yBAAA;ADiDJ;AC3HI;ED8FJ;IAMQ,eAAA;EA2BN;AACF;AA3BI;EACI,iBAAA;EACA,aAAA;AA6BR;AA5BI;EACI,gBAAA;EACA,cC9EH;AD4GL;;AA5BA;EACI,cCjFC;ADgHL;AA9BI;EACI,aCnFH;ADmHL","sourcesContent":["@import ../../styles/helpers\n\n.product\n    &:hover\n        .preview:after,\n        .control,\n        .checkbox\n            visibility: visible\n            opacity: 1\n    &.active\n        .checkbox\n            visibility: visible\n            opacity: 1\n        .preview\n            &:before\n                border-color: $p1\n\n.preview:after,\n.control,\n.checkbox\n    opacity: 0\n    visibility: hidden\n    transition: all .2s\n\n.preview\n    position: relative\n    height: 200px\n    margin-bottom: 16px\n    border-radius: 12px\n    overflow: hidden\n    &:after,\n    &:before\n        content: \"\"\n        position: absolute\n        top: 0\n        left: 0\n        width: 100%\n        height: 100%\n        transition: all .2s\n    &:after\n        background: rgba($n8, .8)\n    &:before\n        z-index: 2\n        border: 2px solid transparent\n        border-radius: 12px\n        pointer-events: none\n    img\n        position: absolute\n        top: 0\n        left: 0\n        width: 100%\n        height: 100%\n        object-fit: cover\n    .checkbox\n        position: absolute\n        top: 12px\n        left: 12px\n        z-index: 3\n        +t\n            display: none \n        .checkboxTick\n            border-color: $p1\n\n.control\n    position: absolute\n    top: 50%\n    left: 50%\n    z-index: 3\n    transform: translate(-50%,-50%)\n\n.line\n    display: flex\n    align-items: flex-start\n\n.title\n    margin-right: auto\n\n.price,\n.empty\n    flex-shrink: 0\n    display: inline-block\n    margin-left: 32px\n    padding: 0 8px\n    border-radius: 6px\n    line-height: 32px\n    font-weight: 700\n\n.price\n    background: $s4\n    +dark\n        color: $n7\n\n.empty\n    background: $n3\n    +dark\n        background: $n6\n        color: $n1\n\n.date\n    display: flex\n    align-items: center\n    margin-top: 8px\n    +base2\n    color: $n4\n    +m\n        margin-top: 2px\n    svg\n        margin-right: 8px\n        fill: $n4\n\n.rating\n    display: flex\n    align-items: center\n    margin-top: 8px\n    +base2\n    +m\n        margin-top: 4px\n    svg\n        margin-right: 8px\n        fill: #FFC554\n    span\n        margin-left: 4px\n        color: $n4\n\n.ratingEmpty\n    color: $n4\n    svg\n        fill: $n4","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product": `fa6bYxvORc63Gv7yrVFD`,
	"preview": `hc5aTtmAmUEUzWdXW3CM`,
	"control": `wjkg05fwSyvZXnjGAFYg`,
	"checkbox": `euFHie3HEGREt0kod_TQ`,
	"active": `am3oNEqAE_oqHZ553f8v`,
	"checkboxTick": `Ah_d4lzc6k2QG8oAo8xy`,
	"line": `Spn9MrPYFe2yeGm1tHr0`,
	"title": `AeGzMBlNmKX5kV4lh80y`,
	"price": `Daro9806tOD8YRw76NEI`,
	"empty": `vV7vQRKAu8RnsM02TuGV`,
	"date": `FUV1uamC7e52Hlvq1bDn`,
	"rating": `HmVWO6n2Ch_70wFP1wW9`,
	"ratingEmpty": `QPppTLeNGMGW3NDy9Znt`
};
export default ___CSS_LOADER_EXPORT___;
